<bootstrap-popup [id]="id" [displaySubject]="displaySubject" [title]="'Signer le PA'"> 
	
<pannel [title]="'Signataires'" [expandable]="true">

	<table class="mat-table signataires-table" *ngIf="euEeData">

		<tr class="mat-header-row">
			<th>Nom / Prénom</th>
			<th class="email-col">Email</th>
			<th>Signer</th>
		</tr>
		<tr class="global-operations">
			<td colspan="2">Tous cocher</td>
			<td class="sign-cb">
				<mat-checkbox [(ngModel)]="signAll" color="primary" (change)="onCheckAllSignataires()"></mat-checkbox>
			</td>
		</tr>

		<!-- ================= EU ================= -->
		<tr class="entreprise-break">
			<td colspan="3">
				<strong class="entreprise-label">{{ euEeData.raisonSocialeEu }}</strong>
			</td>
		</tr>

		<tr>
			<td>
				<strong>{{ euEeData.nomPrenomResponsableEu }}</strong>
			</td>
			<td class="email-col">
				<input class="form-control" [(ngModel)]="euEeData.emailResponsableEu" readonly />
			</td>
			<td class="sign-cb">
				<mat-checkbox [(ngModel)]="euEeData.euHasSigned" color="primary" (change)="refreshSignAll()"></mat-checkbox>
			</td>
		</tr>

		<!-- ================= EE ================= -->
		<tr class="entreprise-break">
			<td colspan="3">
				<strong class="entreprise-label">{{ euEeData.raisonSocialeEe }}</strong>
			</td>
		</tr>

		<tr>
			<td>
				<strong>{{ euEeData.nomPrenomResponsableEe }}</strong>
			</td>
			<td class="email-col">
				<input class="form-control" [(ngModel)]="euEeData.emailResponsableEe" readonly />
			</td>
			<td class="sign-cb">
				<mat-checkbox [(ngModel)]="euEeData.eeHasSigned" color="primary" (change)="refreshSignAll()"></mat-checkbox>
			</td>
		</tr>

	</table>

</pannel>

<div class="row">
	<div class="col-md-12">
		<div class="form-group text-center">
			<button type="button" class="btn btn-success" style="margin-right: 10px" (click)="onCloseRequested()">Fermer</button>
			<button type="button" class="btn btn-primary" style="margin-right: 6px" (click)="onSaveRequested()" title = "Sauvegarder" >Sauvegarder</button>
		</div>
	</div>
</div>
</bootstrap-popup>


